import React, { useEffect } from 'react';
import { showSuccess, showError } from '../services/reactToastify';
import { axiosSpring } from '../Hooks/axios';
// import useRazorPay from "razorpay";
const PaymentButton = ({ amount, planName, onSuccess }) => {

    // Load Razorpay script dynamically
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    // const Razorpay = useRazorPay()

    const handlePayment = async () => {
        try {

            // Step 1: Create Order on Backend
            const { data } = await axiosSpring.post('/api/payment/create-order', {
                amount: amount,           // e.g., 499 for ₹499
                planName: planName
            });
            // console.log(data)

            // const rzp = new Razorpay()

            const options = {
                key: data.key,                    // Razorpay Key ID
                amount: data.amount,
                currency: data.currency,
                order_id: data.orderId,
                name: "AetherForgeWorkspace",
                description: planName || "Workspace Subscription",
                image: "/logo.png",               // Optional
                // method: {
                //     upi: true,           // Enable UPI
                //     card: true,
                //     netbanking: true,
                //     wallet: true
                // },
                config: {
                    display: {
                        blocks: {
                            upi: {
                                name: 'Pay using UPI',
                                instruments: [
                                    { method: 'upi' }
                                ]
                            }
                        },
                        hide: [], // Explicitly don't hide anything
                    
                    }
                },
                handler: async function (response) {
                    try {
                        // Step 2: Verify Payment
                        const verifyRes = await axiosSpring.post('/api/payment/verify', {
                            razorpayOrderId: response.razorpay_order_id,
                            razorpayPaymentId: response.razorpay_payment_id,
                            razorpaySignature: response.razorpay_signature
                        });

                        if (verifyRes.data.status === "success") {
                            showSuccess("Payment Successful! 🎉");
                            if (onSuccess) onSuccess(response);
                        }
                    } catch (err) {
                        showError("Payment verification failed");
                    }
                },

                prefill: {
                    name: "Your Name",
                    email: "user@example.com",
                    contact: "9999999999"
                },

                theme: {
                    color: "#8b5cf6"
                }
            };
            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch (err) {
            showError("Failed to initiate payment");
            console.error(err);
        }
    };

    return (
        <button
            onClick={handlePayment}
            className="w-full py-4 cursor-pointer bg-violet-600 hover:bg-violet-500 rounded-3xl font-semibold text-lg transition-all"
        >
            Pay ₹{amount}
        </button>
    );
};

export default PaymentButton;